import { isObject } from 'lodash-es';

/**
 * Acloset 기본 에러.
 */
export class AclosetError extends Error {
  _aclosetError = true;

  constructor(error: any) {
    super();

    if (typeof error === 'string') {
      this.message = error;
    } else if (error instanceof Error) {
      this.message = error.message;
      this.name = error.name;
      this.stack = error.stack;
    } else {
      this.message = 'Unknown error';
    }
  }

  toString() {
    return this.message;
  }

  /**
   * 사용자를 위한 메시지를 가져옵니다.
   */
  get userMessage() {
    return 'Unknown error';
  }
}

/**
 * AclosetError 타입 체크.
 */
export const isAclosetError = (obj: any): obj is AclosetError => {
  return isObject(obj) && '_aclosetError' in obj;
};
